var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8DoubleTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.385,
    height: 14,
    viewBox: "0 0 19.385 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icons8-double-tick",
    d: "M20.535,10.985a.807.807,0,0,0-.55.256l-9.166,9.58L9.7,21.99l-.989,1.033L3.378,17.687a.807.807,0,1,0-1.142,1.142l5.921,5.919a.808.808,0,0,0,1.154-.013l1.535-1.6,1.116-1.167,9.19-9.607a.807.807,0,0,0-.617-1.373Z",
    transform: "translate(-2 -10.984)",
    fill: "#2a60bc"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8DoubleTick);
export default __webpack_public_path__ + "static/media/icons8-double-tick.c4ff61fd9928bdd6a3344625b45297f7.svg";
export { ForwardRef as ReactComponent };